import { v4 as uuid } from "uuid";
import styled, { keyframes } from "styled-components";
import { shake, zoomIn } from "react-animations";
const shakeAnimation = keyframes`${shake}`;
const zoomAnimation = keyframes`${zoomIn}`;

const CardCont = styled.div`
  width: 90%;
  display: flex;
  padding: 20px;
  flex-wrap: wrap;
  justify-content: center;
  animation: 3s ${zoomAnimation};
  margin: 9% auto;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 20px;
  box-shadow: 0 0 5px 5px #b026ff;

  & > div {
    width: 8%;
    color: black;
    font-family: "Comic Neue", cursive;
    font-size: 20px;
    font-weight: bold;
    background-color: white;
    opacity: 0.8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
    text-align: center;
    margin: 1.5%;
    border-radius: 30px;
  }
  & > div:hover {
    animation: 1s ${shakeAnimation};
    cursor: pointer;
  }
  & > div > img {
    width: 80%;
    margin-bottom: 5%;
  }
  @media screen and (max-width: 768px) {
    width: 80%;
    display: flex;
    padding: 20px;
    flex-wrap: wrap;
    justify-content: center;
    animation: 3s ${zoomAnimation};
    margin: 8% auto;
    background-color: rgba(0, 0, 0, 0.8);
    border-radius: 10px;
    box-shadow: 0 0 5px 5px #b026ff;

    & > div {
      width: 25%;
      color: black;
      font-family: "Comic Neue", cursive;
      font-size: 18px;
      font-weight: bold;
      background-color: white;
      opacity: 0.8;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      text-align: center;
      margin: 3%;
      border-radius: 10px;
    }
  }
`;

export const SkillCard = ({ skills }) => {
  return (
    <CardCont>
      {skills.map((el) => {
        return (
          <div key={uuid()}>
            <img src={el.image} alt="skill" />
            <p>{el.name}</p>
          </div>
        );
      })}
    </CardCont>
  );
};
